import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import s from './SendForInternalReviewModal.scss'
import Select from 'react-select'
import * as ACT from './actions'
import { toUsersSelect } from 'components/Users/serializers'
import { Checkbox } from 'components/ideal-core-ui'
import { useParams } from 'react-router-dom'

const selectProposalReviewers = createSelector(
  [state => state.proposalReviewers],
  proposalReviewers => {
    return proposalReviewers
  }
)

const SendForInternalReviewModal = ({
  sendForInternalReview,
  showSendForInternalReviewModal,
  toggleSendForInternalReviewModal,
  proposals,
  toggleSelectProposal,
  size = 'md',
  selectedProposals
}) => {
  const [selectedUsers, setSelectedUsers] = useState([])

  const proposalReviewers = useSelector(state => selectProposalReviewers(state.users))

  const dispatch = useDispatch()
  const { id } = useParams()

  useEffect(() => {
    setSelectedUsers(toUsersSelect(proposalReviewers))
  }, [proposalReviewers])

  useEffect(() => {
    dispatch({ type: ACT.PROPOSAL_REVIWEWERS_FETCH_REQUESTED, payload: { dealId: id } })
  }, [id, dispatch])

  const isDisabled = proposals?.length
    ? !selectedProposals.length || !selectedUsers.length
    : !selectedUsers.length

  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={showSendForInternalReviewModal}
        toggle={toggleSendForInternalReviewModal}
        size={size}
      >
        <ModalHeader toggle={toggleSendForInternalReviewModal} className={s.modalHeader}>
          Send for Internal Review
        </ModalHeader>
        <ModalBody>
          {proposals?.length > 0 && (
            <div className={s.proposalsWrapper}>
              <p>Select which proposals you&#39;d like to review</p>
              {proposals.map(proposal => (
                <div key={proposal.id}>
                  <Checkbox
                    isChecked={selectedProposals.includes(proposal.id)}
                    triggerCheckbox={() => toggleSelectProposal(proposal.id)}
                  />
                  <span>{proposal.name}</span>
                </div>
              ))}
            </div>
          )}
          <p>Select the persons you&#39;d like to review the Proposal.</p>
          <Select
            onChange={value => setSelectedUsers(value)}
            options={toUsersSelect(proposalReviewers)}
            value={selectedUsers}
            isMulti
          />
        </ModalBody>
        <ModalFooter>
          <Button
            className={s.saveBtn}
            disabled={isDisabled}
            onClick={() => sendForInternalReview(selectedUsers)}
          >
            Send
          </Button>
          <Button color="secondary" onClick={toggleSendForInternalReviewModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default SendForInternalReviewModal
